import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import WorkPage from "pages/WorkPage";
import MainPage from "pages/MainPage";
import NavBar from "components/AppLayout/NavBar";
import DevelopPage from "pages/DevelopPage";
import ContactPage from "pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import BlobTry from "./assets/BlobTry";
import MagneticCursor from "./components/MagneticCursor";

export default function App() {
  const [sectionControls] = useState({
    mainPage: useAnimation(),
    aboutPage: useAnimation(),
    developPage: useAnimation(),
    workPage: useAnimation(),
    contactPage: useAnimation(),
  });

  const [mainPageRef, mainPageInView] = useInView();
  const [aboutPageRef, aboutPageInView] = useInView({ threshold: 0.3 });
  const [developPageRef, developPageInView] = useInView({ threshold: 0.3 });
  const [workPageRef, workPageInView] = useInView({ threshold: 0.3 });
  const [contactPageRef, contactPageInView] = useInView({ threshold: 0.3 });

  useEffect(() => {
    if (mainPageInView) {
      sectionControls.mainPage.start({ opacity: 1 });
    } else {
      sectionControls.mainPage.start({ opacity: 0 });
    }

    if (aboutPageInView) {
      sectionControls.aboutPage.start({ opacity: 1 });
    } else {
      sectionControls.aboutPage.start({ opacity: 0 });
    }

    if (developPageInView) {
      sectionControls.developPage.start({ opacity: 1 });
    } else {
      sectionControls.developPage.start({ opacity: 0 });
    }

    if (workPageInView) {
      sectionControls.workPage.start({ opacity: 1 });
    } else {
      sectionControls.workPage.start({ opacity: 0 });
    }

    if (contactPageInView) {
      sectionControls.contactPage.start({ opacity: 1 });
    } else {
      sectionControls.contactPage.start({ opacity: 0 });
    }
  }, [
    sectionControls.mainPage,
    sectionControls.aboutPage,
    sectionControls.developPage,
    sectionControls.workPage,
    sectionControls.contactPage,
    mainPageInView,
    aboutPageInView,
    developPageInView,
    workPageInView,
    contactPageInView,
  ]);

  return (
    <Box sx={{ display: "flex", height: "100vh", alignItems: "center" }}>
      {/* Cursor highlight overlay */}
      <MagneticCursor />

      {/* Scroll-reactive background blob */}
      <BlobTry />

      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <NavBar />
      </Box>
      <Box
        sx={{
          height: "100vh",
          width: { xs: "100%", md: "90vw" },
          padding: { xs: "35px", md: 0 },
          paddingLeft: { md: "10vw" },
          transition: "padding-left 0.3s",
          gap: 7,
        }}
      >
        <motion.div
          ref={mainPageRef}
          initial={{ opacity: 0 }}
          animate={sectionControls.mainPage}
          transition={{ duration: 1 }}
        >
          <MainPage />
        </motion.div>

        <motion.div
          ref={aboutPageRef}
          initial={{ opacity: 0 }}
          animate={sectionControls.aboutPage}
          transition={{ duration: 1 }}
        >
          <AboutPage />
        </motion.div>

        <motion.div
          ref={developPageRef}
          initial={{ opacity: 0 }}
          animate={sectionControls.developPage}
          transition={{ duration: 1 }}
        >
          <DevelopPage />
        </motion.div>

        <motion.div
          ref={workPageRef}
          initial={{ opacity: 0 }}
          animate={sectionControls.workPage}
          transition={{ duration: 1 }}
        >
          <WorkPage />
        </motion.div>

        <motion.div
          ref={contactPageRef}
          initial={{ opacity: 0 }}
          animate={sectionControls.contactPage}
          transition={{ duration: 1 }}
        >
          <ContactPage />
        </motion.div>
      </Box>
    </Box>
  );
}
